export default class FeCourse {
    /**
     * @type {string}
     * @memberof FeCourse
     * @name 课程Id
     */
    public courseId: string;
    /**
     * @type {string}
     * @memberof FeCourse
     * @name 课程编号
     */
    public no: string;
    /**
     * @type {string}
     * @memberof FeCourse
     * @name 课程名字
     */
    public name: string;
    /**
     * @type {string}
     * @memberof FeCourse
     * @name 课程类型:必修，必选，选修
     */
    public category: string;
    /**
     * @type {string}
     * @memberof FeCourse
     * @name 国家课程，校本课程
     */
    public type: string;
    /**
     * @type {string}
     * @memberof FeCourse
     * @name 国家课程，校本课程
     */
    public typeName: string;
    /**
     * @type {string}
     * @memberof FeCourse
     * @name 科目主键
     */
    public subjectId: string;
    /**
     * @type {string}
     * @memberof FeCourse
     * @name 学段常量,多个学段用逗号分隔（小学，初中，高中）空代表全学段
     */
    public studySections: string;
    /**
     * @type {string}
     * @memberof FeCourse
     * @name 学分
     */
    public credit: string;
    constructor({
        courseId = '',
        no = '',
        name = '',
        category = '',
        type = '',
        typeName = '',
        subjectId = '',
        studySections = '',
        credit = ''
    } = {}) {
        this.courseId = courseId,
        this.no = no,
        this.name = name,
        this.category = category,
        this.type = type,
        this.typeName = typeName,
        this.subjectId = subjectId,
        this.studySections = studySections,
        this.credit = credit
    }
}